import { useEffect, useRef } from 'react';
import { useAuthStore } from '@/stores/authStore';
import { env } from '@/config/env';

declare global {
  interface Window {
    Tawk_API?: {
      visitor?: { name: string; email: string };
      maximize?: () => void;
      minimize?: () => void;
      toggle?: () => void;
      onLoad?: () => void;
    };
    Tawk_LoadStart?: Date;
  }
}

export function openTawkChat() {
  if (typeof window.Tawk_API?.maximize === 'function') {
    window.Tawk_API.maximize();
  }
}

export default function TawkChat() {
  const user = useAuthStore((s) => s.user);
  const company = useAuthStore((s) => s.company);
  const scriptRef = useRef<HTMLScriptElement | null>(null);

  const propertyId = env.TAWK_PROPERTY_ID;
  const widgetId = env.TAWK_WIDGET_ID;

  useEffect(() => {
    if (!propertyId || !widgetId || scriptRef.current) return;

    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_LoadStart = new Date();

    if (user) {
      window.Tawk_API.visitor = {
        name: user.full_name,
        email: user.email,
      };
    }

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://embed.tawk.to/${propertyId}/${widgetId}`;
    script.charset = 'UTF-8';
    script.setAttribute('crossorigin', '*');
    document.head.appendChild(script);
    scriptRef.current = script;

    return () => {
      if (scriptRef.current) {
        document.head.removeChild(scriptRef.current);
        scriptRef.current = null;
      }
      // Remove Tawk.to injected DOM elements
      const tawkContainer = document.getElementById('tawk-container');
      if (tawkContainer) tawkContainer.remove();
      delete window.Tawk_API;
      delete window.Tawk_LoadStart;
    };
  }, [propertyId, widgetId]);

  // Update visitor info if user changes after script is already loaded
  useEffect(() => {
    if (!user || !window.Tawk_API) return;
    window.Tawk_API.visitor = {
      name: user.full_name,
      email: user.email,
    };
  }, [user, company]);

  return null;
}
